import { Moon, Sun } from "lucide-react";
import { api } from "../api/client";
import { Button } from "../components/Button";
import { useToast } from "../components/Toast";
import { applyTheme, effectiveTheme, useThemeChoice } from "../theme/theme";

// 鈴鐺旁邊那顆亮色 / 暗色切換鈕(業主 2026-09-25)。
//
// 圖示畫的是「按下去會變成什麼」:亮色時是月亮,暗色時是太陽 ——
// 可存取名稱也照這個說法,讀出來就知道按了會發生什麼事。
//
// 先套用、再存:存到帳號上要等一趟網路,畫面不該跟著等。存不進去時
// 畫面照樣換了,只是提醒一聲 —— 下次開頁會回到帳號上的那一個。

export function ThemeToggle() {
  const { push } = useToast();
  const choice = useThemeChoice();
  const next = effectiveTheme(choice) === "dark" ? "light" : "dark";

  const toggle = () => {
    applyTheme(next);
    api.put("/users/me/theme", { theme: next }).catch(() => {
      push("主題沒存到帳號上,下次開頁可能會變回原本的樣子", "error");
    });
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggle}
      aria-label={next === "dark" ? "切換成暗色主題" : "切換成亮色主題"}
      title={next === "dark" ? "切換成暗色主題" : "切換成亮色主題"}
      icon={next === "dark" ? <Moon aria-hidden="true" size={16} /> : <Sun aria-hidden="true" size={16} />}
    />
  );
}
